export enum NumericUnit {
  pcs = 'szt',
  set = 'kpl',

  mm = 'mm',
  cm = 'cm',
  m = 'm',
  km = 'km',
  ft = 'ft',
  in = 'in',
  mi = 'mi',

  mm2 = 'mm²',
  cm2 = 'cm²',
  m2 = 'm²',
  ft2 = 'ft²',

  cm3 = 'cm³',
  m3 = 'm³',
  ft3 = 'ft³',
  ml = 'ml',
  l = 'l',
  gal = 'gal',

  g = 'g',
  kg = 'kg',
  t = 't',
  lb = 'lb',
  oz = 'oz',

  N = 'N',
  kN = 'kN',

  Celsius = '°C',
  Fahrenheit = '°F',

  bar = 'bar',
  PSI = 'PSI',
  kPa = 'kPa',
  MPa = 'MPa',

  V = 'V',
  mA = 'mA',
  A = 'A',
  Ohm = 'Ω',
  kOhm = 'kΩ',
  Hz = 'Hz',
  W = 'W',
  kW = 'kW',
  kWh = 'kWh',
  kVA = 'kVA',

  m3h = 'm³/h',
  ls = 'l/s',

  s = 's',
  min = 'min',
  h = 'h',

  percent = '%',
  ppm = 'ppm',
  dB = 'dB',
  lux = 'lux',
}

export const numericUnits = Object.values(NumericUnit);

export function isNumericUnit(value: unknown): value is NumericUnit {
  return typeof value === 'string' && numericUnits.includes(value as NumericUnit);
}
